import { table } from './_table';

export const form = {
  namespaced: true,
  modules: {
    table
  },
  state: {
    id: null
  },

  mutations: {
    setId(state, id) {
      state.id = id;
    },

    clearId(state) {
      state.id = null;
    }
  }
};
